import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createEppPlanRequest,
  createEppPlanSuccess,
  createEppPlanFailure,
  createZeroPercentEppRequest,
  createZeroPercentEppSuccess,
  createZeroPercentEppFailure,
} from '../reducer/disclosureSummarySlice';
import { createEppPlan, createZeroPercentEpp } from '../api';

interface CreateEppPlanAction {
  type: typeof createEppPlanRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    requestBody: {
      activityId: string;
      optionCode: string;
      planName: string;
      recaptchaToken?:any;
    };
  };
}

interface CreateZeroPercentEppAction {
  type: typeof createZeroPercentEppRequest.type;
  payload: {
    requestBody: any;
  };
}

export function* createEppPlanSaga(
  action: CreateEppPlanAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, requestBody } = action.payload;

    // Extract fields from the requestBody
    const { activityId, optionCode, planName, recaptchaToken } = requestBody || {};

    // Create the request payload with the extracted values
    const apiRequestBody = {
      activityId,
      optionCode,
      planName,
      recaptchaToken:recaptchaToken
    };

    console.log('API Request Body:', JSON.stringify(apiRequestBody));

    const response = yield call(
      createEppPlan,
      'create_epp_plan',
      accountId,
      customerId,
      apiRequestBody
    );

    yield put(createEppPlanSuccess(response));
  } catch (error) {
    console.error('Error creating EPP plan:', error);
    yield put(createEppPlanFailure(error));
  }
}

export function* createZeroPercentEppSaga(
  action: CreateZeroPercentEppAction
): Generator<any, void, unknown> {
  try {
    const { requestBody } = action.payload;

    // Log the request body for debugging
    console.log(
      'Zero Percent EPP API Request Body:',
      JSON.stringify(requestBody)
    );

    const response = yield call(
      createZeroPercentEpp,
      'create_zero_percent_epp',
      requestBody
    );

    yield put(createZeroPercentEppSuccess(response));
  } catch (error) {
    console.error('Error creating zero percent EPP:', error);
    yield put(createZeroPercentEppFailure(error));
  }
}

export function* watchDisclosureSummarySaga() {
  yield takeLatest(createEppPlanRequest.type, createEppPlanSaga);
  yield takeLatest(createZeroPercentEppRequest.type, createZeroPercentEppSaga);
}
